export default __webpack_public_path__ + "locales/fr/ChangeUserTypeDialog.json?hash=c20535741e66dfe600c44dbb6d6d6920";